import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import ProofOfIndentity from 'components/kyc/proof-of-identity';
import ProofOfAddress from 'components/kyc/proof-of-address';
import SelfieWithID from 'components/kyc/selfie-with-id';
import { TYPE_IDENTITY, TYPE_ADDRESS, TYPE_SELFIE } from 'utils/constants';
import PerosnalInfo from 'components/kyc/personal-info';
import KycSC from './kyc.styled';
import { bindActionCreators } from 'redux';
import * as ActionCreators from '../redux/action';

const Kyc = ({
  user: {
    firstName,
    lastName,
    nationality,
    address,
    birthday,
    kyc: { allowedTypes }
  },
  fetchKycStatus,
  fetchUserData
}) => {
  const [withoutExpirationDate, setWithoutExpirationDate] = useState(false);
  const [activeForm, setActiveForm] = useState('');

  const profileComplete =
    firstName &&
    lastName &&
    nationality &&
    address.street &&
    address.city &&
    address.country &&
    address.zip &&
    birthday.day &&
    birthday.month &&
    birthday.year;

  const isIdentityAllowed = allowedTypes.includes(TYPE_IDENTITY);
  const isAddressAllowed = allowedTypes.includes(TYPE_ADDRESS);
  const isSelfieAllowed = allowedTypes.includes(TYPE_SELFIE);

  useEffect(() => {
    fetchKycStatus();
  }, [fetchKycStatus]);

  useEffect(() => {
    fetchUserData();
  }, [fetchUserData]);

  return (
    <KycSC withoutExpirationDate={withoutExpirationDate}>
      <>
        <PerosnalInfo active={!profileComplete} />
        {isIdentityAllowed && (
          <ProofOfIndentity
            active={activeForm === TYPE_IDENTITY}
            setActive={() => setActiveForm(TYPE_IDENTITY)}
            setInactive={() => setActiveForm('')}
            setWithoutExpirationDate={setWithoutExpirationDate}
            showOnly={!profileComplete}
          />
        )}
        {isAddressAllowed && (
          <ProofOfAddress
            active={activeForm === TYPE_ADDRESS}
            setActive={() => setActiveForm(TYPE_ADDRESS)}
            setInactive={() => setActiveForm('')}
            showOnly={!profileComplete}
          />
        )}
        {isSelfieAllowed && (
          <SelfieWithID
            active={activeForm === TYPE_SELFIE}
            setActive={() => setActiveForm(TYPE_SELFIE)}
            setInactive={() => setActiveForm('')}
            showOnly={!profileComplete}
          />
        )}
      </>
    </KycSC>
  );
};

// Kyc.propTypes = {
//   devices: PropTypes.shape({}).isRequired,
//   uploadKycDocument: PropTypes.func.isRequired,
//   cancelKycVerification: PropTypes.func.isRequired,
//   toggleInfoModal: PropTypes.func.isRequired,
//   kyc: PropTypes.shape({
//     status: PropTypes.string.isRequired
//   }).isRequired,
//   responsiveContentView: PropTypes.bool.isRequired,
//   t: PropTypes.func.isRequired
// };

const mapStateToProps = state => {
  return {
    user: state.user
  };
};

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      fetchKycStatus: ActionCreators.fetchKycStatusRequest,
      fetchUserData: ActionCreators.fetchUserData
    },
    dispatch
  );

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(React.memo(Kyc));
